module.exports = __webpack_public_path__ + "static/media/ng.54654edb.svg";